const taskStateEnum = {
    new: 'new',
    pickup: 'pickup',
    finished: 'finished'
}

export default taskStateEnum;